import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Input,
  useToast,
  Stack,
} from '@chakra-ui/react'
import { useState } from 'react'
import { fecharPedidoKangu, limpezaCache } from '../functions'

export function FecharPedidoKangu() {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [loading, setLoading] = useState(false)

  const [inputValues, setInputValues] = useState({
    numero_nota: '',
    nunota_origem: '',
  })

  function handleInputChange(e) {
    const { name, value } = e.target

    setInputValues({ ...inputValues, [name]: value })
  }

  const toast = useToast({
    position: 'top',
  })

  async function handleFecharPedido(e) {
    e.preventDefault()
    setLoading(true)

    const response = await fecharPedidoKangu({
      numero_nota: inputValues.numero_nota,
      nunota_origem: inputValues.nunota_origem,
    })

    if (response.status === 200) {
      toast({
        title: 'Sucesso!',
        description: 'Pedido fechado com sucesso!',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })

      onClose()
    }

    setLoading(false)
  }

  return (
    <>
      <Button onClick={onOpen} variant="outline" maxW="300px" w="100%">
        Fechar pedido - Kangu
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleFecharPedido}>
          <ModalHeader>Fechar pedido kangu</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack spacing="1rem">
              <Input
                placeholder="Digite o número da nota"
                name="numero_nota"
                onChange={handleInputChange}
              />
              <Input
                placeholder="Digite o número da nota de origem"
                name="nunota_origem"
                onChange={handleInputChange}
              />
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button variant="ghost" type="submit" isLoading={loading}>
              Fechar pedido
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
